(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[228],{

/***/ 4956:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forms",
      function () {
        return __webpack_require__(8188);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Forms; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var content_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5938);
/* provided dependency */ var process = __webpack_require__(3454);
// "use client";
// import WhatsAppLink from "./whatsapp-component";









var DEFAULT_WHATSAPP_GROUP_LINK = process.env.NEXT_PUBLIC_ARC_WHATSAPP_GROUP_LINK || "https://chat.whatsapp.com/Br6BWjF0cB3Cfj1BbBJHGH?mode=gi_t";
// const isRegistrationOpen = now > deadline;
// const isRegistrationOpen = false;
// Validation constants and utilities
var FIELD_VALIDATIONS = {
    teamName: {
        pattern: /^[\u0621-\u064AA-Za-z\s]{2,}$/,
        message: "Name should only contain Arabic or English letters and single spaces",
        doubleSpaceMessage: "Name should not contain consecutive spaces"
    },
    name: {
        pattern: /^[\u0621-\u064AA-Za-z\s]{2,}$/,
        message: "Name should only contain Arabic or English letters and single spaces",
        doubleSpaceMessage: "Name should not contain consecutive spaces"
    },
    phone: {
        pattern: /^(010|011|012|015)\d{8}$/,
        message: "Phone number must start with (010, 011, 012, 015) and be 11 digits"
    },
    email: {
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Please enter a valid email address"
    },
    nationalID: {
        pattern: /^\d{14}$/,
        message: "National ID must be exactly 14 numbers"
    },
    institution: {
        pattern: /^[A-Za-z\s&\-.()]{2,}$/,
        message: "Please enter a valid institution name (letters, spaces, and common symbols only)"
    },
    government: {
        pattern: /^[\u0621-\u064AA-Za-z\s]{2,}$/,
        message: "Government Name should only contain Arabic or English letters and single spaces",
        doubleSpaceMessage: "GovernmentName should not contain consecutive spaces"
    }
};
// Unified validation system
var validate = function(value, fieldType) {
    if (!fieldType || !FIELD_VALIDATIONS[fieldType]) return "";
    var validation = FIELD_VALIDATIONS[fieldType];
    // Check for double spaces first if applicable
    if (validation.doubleSpaceMessage && value.includes("  ")) {
        return validation.doubleSpaceMessage;
    }
    // Then check pattern
    if (!validation.pattern.test(value)) {
        return validation.message;
    }
    return "";
};
// Toast notification component
var Toast = function(param) {
    var message = param.message, type = param.type, onClose = param.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-slideIn fixed right-4 top-4 z-50 rounded-lg p-4 shadow-lg\n                    backdrop-blur-md transition-all duration-300\n                    ".concat(type === "success" ? "border border-green-400/30 bg-transparent text-white" : "border border-red-400/30 bg-red-500/90 text-white"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-xl",
                    children: type === "success" ? "✨" : "❌"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "font-medium",
                    children: message
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: onClose,
                    className: "ml-4 text-white/80 transition-colors hover:text-white",
                    "aria-label": "Close notification",
                    children: "\xd7"
                })
            ]
        })
    });
};
var __N_SSG = true;
function Forms(param) {
    var regiterationState = param.regiterationState;
    var isRegistrationOpen = Boolean(regiterationState === null || regiterationState === void 0 ? void 0 : regiterationState.isOpen);
    // Initial state
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        teamName: "",
        members: [
            {
                name: "",
                phone: "",
                email: "",
                nationalID: "",
                studyYear: "",
                university: "",
                faculty: "",
                government: ""
            },
            {
                name: "",
                phone: "",
                email: "",
                nationalID: "",
                studyYear: "",
                university: "",
                faculty: "",
                government: ""
            }, 
        ]
    }), team = ref[0], setTeam = ref[1];
    var TEAM_MEMBER_LIMIT = 5;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSubmitting = ref1[0], setIsSubmitting = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), errors = ref2[0], setErrors = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        show: false,
        message: "",
        type: ""
    }), notification = ref3[0], setNotification = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        show: false,
        joinLink: ""
    }), registrationSuccess = ref4[0], setRegistrationSuccess = ref4[1];
    // Field type mapping
    var getFieldType = function(fieldName) {
        var fieldTypeMap = {
            teamName: "teamName",
            name: "name",
            phone: "phone",
            email: "email",
            nationalID: "nationalID",
            university: "institution",
            faculty: "institution",
            government: "government"
        };
        return fieldTypeMap[fieldName] || fieldName;
    };
    // Simplified handle change function
    var handleChange = function(e, index) {
        var _target = e.target, name = _target.name, value = _target.value;
        if (index !== undefined) {
            // Member field validation
            var fieldType = getFieldType(name);
            var validationError = validate(value, fieldType);
            setErrors(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, "member".concat(index, "_").concat(name), validationError));
            });
            var newMembers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(team.members);
            newMembers[index][name] = value;
            setTeam((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, team), {
                members: newMembers
            }));
        } else {
            // Team field validation
            var fieldType1 = getFieldType(name);
            var validationError1 = validate(value, fieldType1);
            setErrors(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, name, validationError1));
            });
            setTeam((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, team), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, name, value)));
        }
    };
    // Add member
    var addMember = function() {
        if (team.members.length < TEAM_MEMBER_LIMIT) {
            setTeam((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, team), {
                members: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(team.members).concat([
                    {
                        name: "",
                        phone: "",
                        email: "",
                        nationalID: "",
                        studyYear: "",
                        university: "",
                        faculty: "",
                        government: ""
                    }, 
                ])
            }));
        }
    };
    // Remove member
    var removeMember = function(index) {
        if (team.members.length > 1) {
            var newMembers = team.members.filter(function(_, i) {
                return i !== index;
            });
            setTeam((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, team), {
                members: newMembers
            }));
            // Clear errors for removed member
            var newErrors = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, errors);
            Object.keys(newErrors).forEach(function(key) {
                if (key.startsWith("member".concat(index, "_"))) {
                    delete newErrors[key];
                }
            });
            setErrors(newErrors);
        }
    };
    // Validate form before submission
    var validateForm = function() {
        var newErrors = {};
        // Validate team name
        var teamNameError = validate(team.teamName, "teamName");
        if (teamNameError) {
            newErrors.teamName = teamNameError;
        }
        // Validate all members
        team.members.forEach(function(member, index) {
            // Simple fields validation
            [
                "name",
                "phone",
                "email",
                "nationalID",
                "university",
                "faculty",
                "government"
            ].forEach(function(field) {
                var fieldType = getFieldType(field);
                var error = validate(member[field], fieldType);
                if (error) {
                    newErrors["member".concat(index, "_").concat(field)] = error;
                }
            });
            // Study Year special case
            if (!member.studyYear) {
                newErrors["member".concat(index, "_studyYear")] = "Please select a study year";
            }
        });
        return newErrors;
    };
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(e) {
            var formErrors, response, data, joinLink, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        formErrors = validateForm();
                        if (Object.keys(formErrors).length > 0) {
                            setErrors(formErrors);
                            setNotification({
                                show: true,
                                message: "Please fix all errors before submitting",
                                type: "error"
                            });
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            fetch("/api/register", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    teamName: team.teamName,
                                    members: team.members
                                })
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        data = _state.sent();
                        if (response.ok && data.success) {
                            joinLink = data.whatsappGroupLink || data.whatsappLink || DEFAULT_WHATSAPP_GROUP_LINK;
                            setNotification({
                                show: true,
                                message: data.message || "Registration successful! \uD83C\uDF89",
                                type: "success"
                            });
                            setRegistrationSuccess({
                                show: true,
                                joinLink: joinLink
                            });
                            // Reset form after 2 seconds
                            setTimeout(function() {
                                setTeam({
                                    teamName: "",
                                    members: [
                                        {
                                            name: "",
                                            phone: "",
                                            email: "",
                                            nationalID: "",
                                            studyYear: "",
                                            university: "",
                                            faculty: "",
                                            government: ""
                                        },
                                        {
                                            name: "",
                                            phone: "",
                                            email: "",
                                            nationalID: "",
                                            studyYear: "",
                                            university: "",
                                            faculty: "",
                                            government: ""
                                        }, 
                                    ]
                                });
                                setErrors({});
                            }, 2000);
                        } else {
                            throw new Error(data.message || "Registration failed");
                        }
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        setNotification({
                            show: true,
                            message: error.message || "Failed to register. Please try again.",
                            type: "error"
                        });
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsSubmitting(false);
                        // Auto-hide notification after 5 seconds
                        setTimeout(function() {
                            setNotification({
                                show: false,
                                message: "",
                                type: ""
                            });
                        }, 5000);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative min-h-screen",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-0 -z-10 bg-white dark:bg-gray-900"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                        className: "mb-10 text-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                className: "heading-hero uppercase",
                                children: [
                                    "ARC ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-orange-600",
                                        children: " 10"
                                    }),
                                    " Form",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "heading-pre ml-2 text-sm uppercase tracking-wide",
                                        children: "Registration"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-6 space-y-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900 dark:text-gray-50",
                                        children: "Be Ready For The Challenge"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-gray-500 dark:text-gray-400",
                                        children: "Aswan Robotics Competition"
                                    })
                                ]
                            })
                        ]
                    }),
                    !isRegistrationOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClosedRegistration, {}) : registrationSuccess.show ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RegistrationSuccess, {
                        joinLink: registrationSuccess.joinLink
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-auto max-w-4xl",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "card space-y-8 rounded-lg border border-gray-200 bg-white p-6 shadow-lg transition-shadow hover:shadow-xl dark:border-gray-700 dark:bg-gray-800 md:p-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "border-b border-gray-200 pb-6 dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "text-2xl font-bold text-gray-900 dark:text-gray-50",
                                            children: "Team Registration"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-2 text-sm text-gray-500 dark:text-gray-400",
                                            children: "Form your squad (up to 5 members)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            htmlFor: "teamName",
                                            className: "block text-sm font-medium text-gray-700 dark:text-gray-300",
                                            children: "Team Name"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            id: "teamName",
                                            type: "text",
                                            name: "teamName",
                                            value: team.teamName,
                                            onChange: function(e) {
                                                return handleChange(e, undefined);
                                            },
                                            className: "input-field w-full px-4 py-3 !bg-transparent \n                            ".concat(errors.teamName ? "border-red-500 dark:border-red-500" : ""),
                                            placeholder: "Enter your team name",
                                            required: true
                                        }),
                                        errors.teamName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.teamName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-semibold text-gray-900 dark:text-gray-50",
                                            children: "Team Members"
                                        }),
                                        team.members.map(function(member, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "card space-y-4 rounded-md border border-gray-200 bg-gray-50 p-6 transition-colors hover:border-gray-300 dark:border-gray-700 dark:bg-gray-800/50 dark:hover:border-gray-600",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex items-center justify-between border-b border-gray-200 pb-3 dark:border-gray-700",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                className: "font-semibold text-gray-900 dark:text-gray-50",
                                                                children: index === 0 ? "Team Leader" : "Member ".concat(index + 1)
                                                            }),
                                                            team.members.length > 2 && index > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                type: "button",
                                                                onClick: function() {
                                                                    return removeMember(index);
                                                                },
                                                                className: "text-sm text-red-500 transition-colors hover:text-red-600 dark:text-red-400 dark:hover:text-red-300",
                                                                children: "Remove"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "grid gap-4 sm:grid-cols-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "space-y-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 dark:text-gray-300",
                                                                        children: "Full Name"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "name",
                                                                        value: member.name,
                                                                        onChange: function(e) {
                                                                            return handleChange(e, index);
                                                                        },
                                                                        className: "input-field w-full px-4 py-3 !bg-transparent\n                                     ".concat(errors["member".concat(index, "_name")] ? "border-red-500" : ""),
                                                                        placeholder: "Full Name",
                                                                        required: true
                                                                    }),
                                                                    errors["member".concat(index, "_name")] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "text-sm text-red-500",
                                                                        children: errors["member".concat(index, "_name")]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "space-y-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 dark:text-gray-300",
                                                                        children: "Phone Number"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "phone",
                                                                        value: member.phone,
                                                                        onChange: function(e) {
                                                                            return handleChange(e, index);
                                                                        },
                                                                        className: "input-field w-full px-4 py-3 !bg-transparent\n                                     ".concat(errors["member".concat(index, "_phone")] ? "border-red-500" : ""),
                                                                        placeholder: "01012345678",
                                                                        required: true
                                                                    }),
                                                                    errors["member".concat(index, "_phone")] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "text-sm text-red-500",
                                                                        children: errors["member".concat(index, "_phone")]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "space-y-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 dark:text-gray-300",
                                                                        children: "Email"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "email",
                                                                        name: "email",
                                                                        value: member.email,
                                                                        onChange: function(e) {
                                                                            return handleChange(e, index);
                                                                        },
                                                                        className: "input-field w-full px-4 py-3 !bg-transparent\n                                     ".concat(errors["member".concat(index, "_email")] ? "border-red-500" : ""),
                                                                        placeholder: "email@example.com",
                                                                        required: true
                                                                    }),
                                                                    errors["member".concat(index, "_email")] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "text-sm text-red-500",
                                                                        children: errors["member".concat(index, "_email")]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "space-y-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 dark:text-gray-300",
                                                                        children: "National ID"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "nationalID",
                                                                        value: member.nationalID,
                                                                        onChange: function(e) {
                                                                            return handleChange(e, index);
                                                                        },
                                                                        className: "input-field w-full px-4 py-3 !bg-transparent\n                                    ".concat(errors["member".concat(index, "_nationalID")] ? "border-red-500" : ""),
                                                                        placeholder: "14 digits",
                                                                        maxLength: 14,
                                                                        required: true
                                                                    }),
                                                                    errors["member".concat(index, "_nationalID")] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "text-sm text-red-500",
                                                                        children: errors["member".concat(index, "_nationalID")]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "space-y-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 dark:text-gray-300",
                                                                        children: "University/School"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "university",
                                                                        value: member.university,
                                                                        onChange: function(e) {
                                                                            return handleChange(e, index);
                                                                        },
                                                                        className: "input-field w-full px-4 py-3 !bg-transparent\n                                     ".concat(errors["member".concat(index, "_university")] ? "border-red-500" : ""),
                                                                        placeholder: "Institution name",
                                                                        required: true
                                                                    }),
                                                                    errors["member".concat(index, "_university")] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "text-sm text-red-500",
                                                                        children: errors["member".concat(index, "_university")]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "space-y-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 dark:text-gray-300",
                                                                        children: "Year of Study"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                                        name: "studyYear",
                                                                        value: member.studyYear,
                                                                        onChange: function(e) {
                                                                            return handleChange(e, index);
                                                                        },
                                                                        className: "input-field w-full px-4 py-3",
                                                                        required: true,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                value: "",
                                                                                disabled: true,
                                                                                children: "Select year"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                value: "prep",
                                                                                children: "Preparatory"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                value: "first",
                                                                                children: "First Year"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                value: "second",
                                                                                children: "Second Year"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                value: "third",
                                                                                children: "Third Year"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                value: "fourth",
                                                                                children: "Fourth Year"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "space-y-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 dark:text-gray-300",
                                                                        children: "Faculty/Department"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "faculty",
                                                                        value: member.faculty,
                                                                        onChange: function(e) {
                                                                            return handleChange(e, index);
                                                                        },
                                                                        className: "input-field w-full px-4 py-3 !bg-transparent\n                                    ".concat(errors["member".concat(index, "_faculty")] ? "border-red-500" : ""),
                                                                        placeholder: "Faculty name",
                                                                        required: true
                                                                    }),
                                                                    errors["member".concat(index, "_faculty")] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "text-sm text-red-500",
                                                                        children: errors["member".concat(index, "_faculty")]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "space-y-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        className: "block text-sm font-medium text-gray-700 dark:text-gray-300",
                                                                        children: "City/Governorate"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "government",
                                                                        value: member.government,
                                                                        onChange: function(e) {
                                                                            return handleChange(e, index);
                                                                        },
                                                                        className: "input-field w-full px-4 py-3 !bg-transparent\n                                     ".concat(errors["member".concat(index, "_government")] ? "border-red-500" : ""),
                                                                        placeholder: "Your city",
                                                                        required: true
                                                                    }),
                                                                    errors["member".concat(index, "_government")] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "text-sm text-red-500",
                                                                        children: errors["member".concat(index, "_government")]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        })
                                    ]
                                }),
                                team.members.length < TEAM_MEMBER_LIMIT && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    onClick: addMember,
                                    className: "w-full rounded-md border-2 border-dashed border-gray-300 bg-gray-50 px-4 py-3 text-sm font-medium text-gray-700 transition-colors hover:border-gray-400 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-800/50 dark:text-gray-300 dark:hover:border-gray-500 dark:hover:bg-gray-700/50",
                                    children: "+ Add Team Member"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "submit",
                                    disabled: isSubmitting,
                                    className: "w-full rounded-md bg-orange-500 px-6 py-3 font-medium text-white shadow transition-all duration-200 hover:bg-orange-600 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-orange-600 dark:hover:bg-orange-700 dark:focus:ring-offset-gray-800",
                                    children: isSubmitting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "flex items-center justify-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                className: "h-5 w-5 animate-spin",
                                                viewBox: "0 0 24 24",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                        className: "opacity-25",
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "10",
                                                        stroke: "currentColor",
                                                        strokeWidth: "4",
                                                        fill: "none"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                        className: "opacity-75",
                                                        fill: "currentColor",
                                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    })
                                                ]
                                            }),
                                            "Submitting..."
                                        ]
                                    }) : "Register Team"
                                })
                            ]
                        })
                    }),
                    notification.show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Toast, {
                        message: notification.message,
                        type: notification.type,
                        onClose: function() {
                            return setNotification(function(prev) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, prev), {
                                    show: false
                                });
                            });
                        }
                    }),
                    isSubmitting && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "rounded-lg bg-white p-6 shadow-xl dark:bg-gray-800",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                        className: "h-8 w-8 animate-spin text-orange-500",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4",
                                                fill: "none"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-lg font-medium text-gray-900 dark:text-gray-50",
                                        children: "Processing registration..."
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var ClosedRegistration = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mx-auto max-w-2xl text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "card rounded-lg border border-gray-200 bg-white p-8 shadow-lg dark:border-gray-700 dark:bg-gray-800",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mb-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "w-32 sm:w-40 md:w-48",
                        children: content_layout__WEBPACK_IMPORTED_MODULE_2__/* .HEADER.logo.title */ .y.logo.title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "mb-4 text-3xl font-bold text-gray-900 dark:text-gray-50",
                    children: "Registration Closed"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mb-6 text-lg text-gray-500 dark:text-gray-400",
                    children: "Follow us on social media for future events!"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center gap-4 border-t border-gray-200 pt-6 dark:border-gray-700",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://www.facebook.com/share/19gAeagM9n/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "text-gray-500 transition-colors hover:text-orange-500 dark:text-gray-400",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "h-6 w-6",
                            fill: "currentColor",
                            viewBox: "0 0 24 24",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M18.77,7.46H14.5v-1.9c0-.9.6-1.1,1-1.1h3V.5h-4.33C10.24.5,9.5,3.44,9.5,5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4Z"
                            })
                        })
                    })
                })
            ]
        })
    });
};
var RegistrationSuccess = function(param) {
    var joinLink = param.joinLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mx-auto max-w-2xl text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "card rounded-lg border border-gray-200 bg-white p-8 shadow-lg dark:border-gray-700 dark:bg-gray-800",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "mb-3 text-3xl font-bold text-gray-900 dark:text-gray-50",
                    children: "Registration Submitted Successfully"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mb-6 text-lg text-gray-500 dark:text-gray-400",
                    children: "Your team is registered. Join the WhatsApp group to receive updates and next steps."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: joinLink,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "inline-flex items-center justify-center gap-2 rounded-md bg-green-600 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-green-700",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "h-5 w-5",
                            fill: "currentColor",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M20.52 3.48A11.82 11.82 0 0 0 12.04 0C5.5 0 .17 5.33.17 11.87c0 2.09.55 4.14 1.58 5.94L0 24l6.35-1.67a11.86 11.86 0 0 0 5.68 1.45h.01c6.54 0 11.87-5.33 11.87-11.87 0-3.17-1.23-6.15-3.39-8.43Zm-8.48 18.3h-.01a9.84 9.84 0 0 1-5.02-1.38l-.36-.21-3.77.99 1-3.68-.23-.38a9.84 9.84 0 0 1-1.51-5.24c0-5.43 4.42-9.85 9.86-9.85 2.64 0 5.12 1.02 6.98 2.89a9.77 9.77 0 0 1 2.88 6.97c0 5.44-4.42 9.86-9.85 9.86Zm5.4-7.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.08-.3-.15-1.26-.46-2.4-1.47-.88-.79-1.48-1.76-1.66-2.06-.17-.3-.02-.46.13-.61.14-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.38-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.38-.27.3-1.04 1.01-1.04 2.47 0 1.45 1.06 2.86 1.2 3.06.15.2 2.08 3.17 5.03 4.44.7.3 1.25.48 1.67.62.7.22 1.34.19 1.85.12.56-.08 1.76-.72 2.01-1.41.25-.7.25-1.3.17-1.42-.08-.13-.27-.2-.57-.35Z"
                            })
                        }),
                        "Join WhatsApp Group"
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(4956); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);